export const IconExternal = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
			<g fill="none" fillRule="evenodd">
				<rect width="12" height="12" x="4" y="4" rx="2" />
				<path
					fill="currentColor"
					fillRule="nonzero"
					d="M9,2 L9,4 L6,4 C4.8954305,4 4,4.8954305 4,6 L4,14 C4,15.1045695 4.8954305,16 6,16 L14,16 C15.1045695,16 16,15.1045695 16,14 L16,11 L18,11 L18,14 C18,16.209139 16.209139,18 14,18 L6,18 C3.790861,18 2,16.209139 2,14 L2,6 C2,3.790861 3.790861,2 6,2 L9,2 Z M18,2 L18,9 L16,9 L16,5.414 L6.70710678,14.7071068 L5.29289322,13.2928932 L14.584,4 L11,4 L11,2 L18,2 Z"
				/>
			</g>
		</svg>
	);
};
